module.exports = __webpack_public_path__ + "files/ad674566fade04ff189fc38e3b7ece1a.png";